import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {NgClass} from '@angular/common';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'peps-button-small',
	imports: [
		NgClass,
		RouterLink
	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './button-small.component.html',
})
export class ButtonSmallComponent {

	constructor() {}

	@Input() text: string = '';
	@Input() link: string = '';
	@Input() hrefLink: string = '';
	@Input() type: 'light' | 'dark' = 'light';

}
